import React, { useContext } from 'react';
import { GoDotFill } from 'react-icons/go';
import { Language, LoginUserData } from '../App';
import usePollRemainingTime from '../hooks/usePollRemainingTime';
import { usePollStatus } from '../hooks/usePollStatus';

const PollOptionsView = ({ value, handlePollAnswer, toggleModal }) => {
  const { lang } = useContext(Language)
  const { splashData } = useContext(LoginUserData)
  const user_id = splashData?.user?.id;

  const showVoteModal = (id) => {
    if (user_id === value?.user?.id) {

      toggleModal(id)
    }

  }
  const remainingTime = usePollRemainingTime(value?.time, value?.duration);
  const pollStatus = usePollStatus(value.time, value.duration);
  return (
    <>
      {[value?.option_1, value?.option_2, value?.option_3, value?.option_4]
        .filter(data => data !== "" && data !== null)
        .map((data, index) => (
          <div className="mb-2" key={index}>
            <div className="container mt-3">
              <div
                className={`custom-box cursor no-text-overflow ${pollStatus === lang.poll_closed
                    ? "custom-box-disabled"
                    : "custom-box-enabled"
                  }`}
                onClick={() => {
                  if (pollStatus === lang.poll_closed) return;
                  handlePollAnswer(value?.id, index);
                }}
                aria-disabled={pollStatus === lang.poll_closed ? 'true' : 'false'} 
              >
                {data}
              </div>
            </div>
          </div>
        ))}

      {/* Render vote count and remaining time */}
      <div className="d-flex align-items-center p-2">
        <p
          className="mb-0 cursor custom-mr-color"
          onClick={() => showVoteModal(value.id)}
          
        >
          {value.votes_count} {lang.votes}
        </p>
        {value.duration && <GoDotFill className='text-gray-post' size={10} />}
        <p className="mb-0 text-muted margin-l-5">
          {remainingTime}
        </p>
      </div>
    </>
  );
};

export default PollOptionsView;
